//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'SubscriptionCards',
  props: {
    features: {
      type: Boolean,
      default: false,
    },
    btnLink: {
      type: String,
      default: '/cart',
    },
    backgroundColor: {
      type: String,
      default: 'ctaSecondary',
    },
    allAccess: {
      type: Boolean,
      default: false,
    },
    onlineAccess: {
      type: Boolean,
      default: false,
    },
    bestValue: {
      type: Boolean,
      default: false,
    },
    groupRates: {
      type: Boolean,
      default: false,
    },
    subIcon: {
      type: String,
      default: '//summitproedu.imgix.net/redesign-assets/icons/online_access_new.svg',
    },
    topHeight: {
      type: String,
      default: ' height: 192px;',
    },
  },
};
